// extracted by mini-css-extract-plugin
module.exports = {"treePermissions":"styles_treePermissions__1ADX-"};